"use strict";

exports.__esModule = true;
exports.VerificationEventHandler = void 0;
var _XmlValidation2 = require("../Parsers/XmlValidation");
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } /*
 * COPYRIGHT 2020-2022 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */
/**
 * VerificationEventHandler declares a set of methods that allow clients to provide event information
 * to an ad verification object.
 *
 * It is implemented by AdVerification and clients <b>must</b> call each method at the appropriate time so that
 * the SDK can signal analytics on behalf of the app.
 *
 * <b>Note:</b> passing reason as string to onVerificationEvent is deprecated.  Use an integer instead
 * @hideconstructor
 */
var VerificationEventHandler = exports.VerificationEventHandler = /*#__PURE__*/function (_XmlValidation) {
  _inheritsLoose(VerificationEventHandler, _XmlValidation);
  function VerificationEventHandler() {
    return _XmlValidation.apply(this, arguments) || this;
  }
  var _proto = VerificationEventHandler.prototype;
  /** Indicates that a verification event occurred.
   * Clients should call this method in order to signal a verification event to the SDK.
   * @param {string} event the verification event
   * @param {number} [reason] (optional) the verification reason. If 0 or no value is supplied then no substitution is made.
   */
  _proto.onVerificationEvent = function onVerificationEvent(event, reason) {
    throw new Error("Function must be overridden");
  };
  return VerificationEventHandler;
}(_XmlValidation2.XmlValidation);